import React from 'react';
import PropTypes from 'prop-types';

const DefaultMobileFooter = props => (
  <button className="btn btn-wrapper" onClick={props.stateCreationClickHandler}>
    Create Free {props.page.document_name}
  </button>
);

DefaultMobileFooter.propTypes = {
  page: PropTypes.shape({
    document_name: PropTypes.string.isRequired,
  }).isRequired,
  stateCreationClickHandler: PropTypes.func.isRequired,
};

export default DefaultMobileFooter;



// WEBPACK FOOTER //
// ./src-react/UsaMap/mobile-footers/DefaultMobileFooter.jsx